import type { StyleRule } from '@archipro-design/aria';

export const PaintPicker: StyleRule<{
    desktop: boolean;
}> = ({ theme, desktop }) => ({
    position: 'fixed',
    left: 0,
    top: desktop ? '50%' : 'auto',
    bottom: desktop ? 'auto' : 0,
    width: desktop ? 'auto' : '100%',
    zIndex: desktop
        ? theme.siteVariables.zIndexes.menuItem + 1
        : theme.siteVariables.zIndexes.overlay,
});
